import type { ThemesType } from './themes.type';

export const jrLightTheme: ThemesType = {
  colors: {
    black: '#000000',

    blue: '#0078FF',
    blueLight: '#3393FF',
    blueDark: '#0060CC',

    green: '#2FD665',
    greenLight: '#ABEEC1',
    greenDark: '#1C803C',
    greenBackground: '#EAFAEF',

    yellow: '#FFFF00',
    yellowLight: '#FFFF66',
    yellowDark: '#E6E600',

    orange: '#FF6600',
    orangeLight: '#FF8533',
    orangeDark: '#CC5200',

    red: '#FF2846',
    redLight: '#FF536B',
    redDark: '#E6243F',
    redBackground: '#FFE8EE',

    dark: '#424242',
    medium: '#9B9B9B',
    light: '#F4F4F4',
    superLight: '#FBFBFB',
    white: '#ffffff',

    backgroundDark: '#D2E7FE',
    backgroundLight: '#EBF7FF',
    backgroundSuperLight: '#F5FBFF',
  },
  fonts: {
    primary: {
      extraBold: {
        fontFamily: 'Baloo 2',
        fontWeight: '900',
        fontStyle: 'normal',
      },
      bold: {
        fontFamily: 'Baloo 2',
        fontWeight: 'bold',
        fontStyle: 'normal',
      },
      semiBold: {
        fontFamily: 'Baloo 2',
        fontWeight: '700',
        fontStyle: 'normal',
      },
      medium: {
        fontFamily: 'Baloo 2',
        fontWeight: '600',
        fontStyle: 'normal',
      },
      regular: {
        fontFamily: 'Baloo 2',
        fontWeight: 'normal',
        fontStyle: 'normal',
      },
      light: {
        fontFamily: 'Baloo 2',
        fontWeight: '300',
        fontStyle: 'normal',
      },
      thin: {
        fontFamily: 'Baloo 2',
        fontWeight: '200',
        fontStyle: 'normal',
      },
      italic: {
        fontFamily: 'Baloo 2',
        fontWeight: 'normal',
        fontStyle: 'italic',
      },
    },
    secondary: {
      extraBold: {
        fontFamily: 'Inter',
        fontWeight: '900',
        fontStyle: 'normal',
      },
      bold: {
        fontFamily: 'Inter',
        fontWeight: 'bold',
        fontStyle: 'normal',
      },
      semiBold: {
        fontFamily: 'Inter',
        fontWeight: '700',
        fontStyle: 'normal',
      },
      medium: {
        fontFamily: 'Inter',
        fontWeight: '600',
        fontStyle: 'normal',
      },
      regular: {
        fontFamily: 'Inter',
        fontWeight: 'normal',
        fontStyle: 'normal',
      },
      light: {
        fontFamily: 'Inter',
        fontWeight: '300',
        fontStyle: 'normal',
      },
      thin: {
        fontFamily: 'Inter',
        fontWeight: '200',
        fontStyle: 'normal',
      },
      italic: {
        fontFamily: 'Inter',
        fontWeight: 'normal',
        fontStyle: 'italic',
      },
    },
  },
  screenSizes: {
    xs: '360px',
    sm: '576px',
    md: '768px',
    lg: '992px',
    xl: '1200px',
    xxl: '1400px',
  },
};
